import PropTypes from 'prop-types';
import NtaPostSubmitPage from './NtaPostSubmitPage';
import {
  PostSubmitButton,
  PostSubmitButtonRow,
  PostSubmitMessage
} from './NtaPostSubmit.styles';

const NtaSubmitConfirmPage = ({ isPending, onConfirm, onCancel }) => (
  <NtaPostSubmitPage>
    <PostSubmitMessage>
      Thank you, your response will be submitted for final marking - click OK to
      complete final submission.
    </PostSubmitMessage>
    <PostSubmitButtonRow>
      <PostSubmitButton
        type="button"
        $width="63px"
        $disabled={isPending}
        disabled={isPending}
        onClick={onConfirm}
      >
        OK
      </PostSubmitButton>
      <PostSubmitButton
        type="button"
        $width="98px"
        $disabled={isPending}
        disabled={isPending}
        onClick={onCancel}
      >
        CANCEL
      </PostSubmitButton>
    </PostSubmitButtonRow>
  </NtaPostSubmitPage>
);

NtaSubmitConfirmPage.propTypes = {
  isPending: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};

export default NtaSubmitConfirmPage;
